import { render, staticRenderFns } from "./ArticleManagerTableHeader.vue?vue&type=template&id=60df50c2"
import script from "./ArticleManagerTableHeader.vue?vue&type=script&lang=ts"
export * from "./ArticleManagerTableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports